module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _Droplist = __webpack_require__(2);
    Object.defineProperty(exports, "default", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Droplist).default;
        }
    });
    var _Item = __webpack_require__(19);
    Object.defineProperty(exports, "Item", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Item).default;
        }
    });
    var _Group = __webpack_require__(27);
    Object.defineProperty(exports, "Group", {
        enumerable: !0,
        get: function() {
            return _interopRequireDefault(_Group).default;
        }
    });
    var _Item2 = __webpack_require__(24);
    Object.defineProperty(exports, "SecondaryText", {
        enumerable: !0,
        get: function() {
            return _Item2.SecondaryText;
        }
    });
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _reactDom = __webpack_require__(8), _reactDom2 = _interopRequireDefault(_reactDom), _layer = __webpack_require__(9), _layer2 = _interopRequireDefault(_layer), _spinner = __webpack_require__(10), _spinner2 = _interopRequireDefault(_spinner), _styledComponents = __webpack_require__(11), _theme = __webpack_require__(12), _Droplist = __webpack_require__(13), _Droplist2 = _interopRequireDefault(_Droplist), _itemTheme = __webpack_require__(16), _itemTheme2 = _interopRequireDefault(_itemTheme), halfFocusRing = 1, dropOffset = "0 " + (0, 
    _theme.gridSize)() + "px", Droplist = function(_Component) {
        function Droplist() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, Droplist);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [ this ].concat(args))), 
            _this.componentDidMount = function() {
                _this.setContentWidth(), // We use a captured event here to avoid a radio or checkbox dropdown item firing its
                // click event first, which would cause a re-render of the element and prevent Droplist
                // from detecting the actual source of this original click event.
                document.addEventListener("click", _this.handleClickOutside, !0), document.addEventListener("keydown", _this.handleEsc);
            }, _this.componentDidUpdate = function() {
                _this.props.isOpen && _this.setContentWidth();
            }, _this.componentWillUnmount = function() {
                document.removeEventListener("click", _this.handleClickOutside, !0), document.removeEventListener("keydown", _this.handleEsc);
            }, _this.setContentWidth = function() {
                var _this2 = _this, dropContentRef = _this2.dropContentRef, triggerRef = _this2.triggerRef, shouldFitContainer = _this.props.shouldFitContainer;
                // We need to manually set the content width to match the trigger width
                // if props.shouldFitContainer is true
                shouldFitContainer && dropContentRef && triggerRef && (dropContentRef.style.width = triggerRef.offsetWidth - 2 * halfFocusRing + "px");
            }, _this.handleEsc = function(event) {
                "Escape" === event.key && _this.close(event);
            }, _this.handleClickOutside = function(event) {
                if (_this.props.isOpen) {
                    var domNode = _reactDom2.default.findDOMNode(_this);
                    // eslint-disable-line react/no-find-dom-node
                    (!domNode || event.target instanceof Node && !domNode.contains(event.target)) && _this.close(event);
                }
            }, _this.close = function(event) {
                _this.props.onOpenChange({
                    isOpen: !1,
                    event: event
                });
            }, _this.handleContentRef = function(ref) {
                _this.dropContentRef = ref, // If the dropdown has just been opened, we focus on the containing element so the
                // user can tab to the first dropdown item. We will only receive this ref if isOpen
                // is true or null, so no need to check for truthiness here.
                ref && ref.focus();
            }, _this.handleTriggerRef = function(ref) {
                return _this.triggerRef = ref;
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(Droplist, _Component), Droplist.prototype.getChildContext = function() {
            return {
                shouldAllowMultilineItems: this.props.shouldAllowMultilineItems
            };
        }, Droplist.prototype.render = function() {
            var _props = this.props, appearance = _props.appearance, boundariesElement = _props.boundariesElement, children = _props.children, isLoading = _props.isLoading, isOpen = _props.isOpen, maxHeight = _props.maxHeight, onClick = _props.onClick, onKeyDown = _props.onKeyDown, position = _props.position, shouldFitContainer = _props.shouldFitContainer, shouldFlip = _props.shouldFlip, trigger = _props.trigger, layerContent = isOpen ? _react2.default.createElement(_Droplist.Content, {
                "data-role": "droplistContent",
                isTall: "tall" === appearance,
                innerRef: this.handleContentRef,
                maxHeight: maxHeight
            }, isLoading ? _react2.default.createElement(_Droplist.SpinnerContainer, null, _react2.default.createElement(_spinner2.default, {
                size: "small"
            })) : _react2.default.createElement(_styledComponents.ThemeProvider, {
                theme: _itemTheme2.default
            }, _react2.default.createElement("div", null, children))) : null;
            return _react2.default.createElement(_Droplist2.default, {
                fit: shouldFitContainer,
                onClick: onClick,
                onKeyDown: onKeyDown
            }, _react2.default.createElement(_layer2.default, {
                autoFlip: shouldFlip,
                boundariesElement: boundariesElement,
                content: layerContent,
                offset: dropOffset,
                position: position
            }, _react2.default.createElement(_Droplist.Trigger, {
                fit: shouldFitContainer,
                innerRef: this.handleTriggerRef
            }, trigger)));
        }, Droplist;
    }(_react.Component);
    Droplist.propTypes = {
        /**
	    * Controls the appearance of the menu.
	    * Default menu has scroll after its height exceeds the pre-defined amount.
	    * Tall menu has no restrictions.
	    */
        appearance: _propTypes2.default.oneOf([ "default", "tall" ]),
        /** Value passed to the Layer component to determine when to reposition the droplist */
        boundariesElement: _propTypes2.default.oneOf([ "viewport", "window", "scrollParent" ]),
        /** Content that will be rendered inside the layer element. Should typically be
	    * `DropdownItemGroup` or `DropdownItem`, or checkbox / radio variants of those. */
        children: _propTypes2.default.node,
        /** If true, a Spinner is rendered instead of the items */
        isLoading: _propTypes2.default.bool,
        /** Controls the open state of the drop list. */
        isOpen: _propTypes2.default.bool,
        onClick: _propTypes2.default.func,
        onKeyDown: _propTypes2.default.func,
        onOpenChange: _propTypes2.default.func,
        /** Position of the menu. See the documentation of @atlastkit/layer for more details. */
        position: _propTypes2.default.string,
        /** Deprecated. Option to display multiline items when content is too long.
	    * Instead of ellipsing the overflown text it causes item to flow over multiple lines.
	    */
        shouldAllowMultilineItems: _propTypes2.default.bool,
        /** Option to fit dropdown menu width to its parent width */
        shouldFitContainer: _propTypes2.default.bool,
        /** Allows the dropdown menu to be placed on the opposite side of its trigger if it does not
	    * fit in the viewport. */
        shouldFlip: _propTypes2.default.bool,
        /** Controls the height at which scroll bars will appear on the drop list. */
        maxHeight: _propTypes2.default.number,
        /** Content which will trigger the drop list to open and close. */
        trigger: _propTypes2.default.node
    }, Droplist.defaultProps = {
        appearance: "default",
        boundariesElement: "viewport",
        children: null,
        isLoading: !1,
        isOpen: !1,
        onClick: function() {},
        onKeyDown: function() {},
        onOpenChange: function() {},
        position: "bottom left",
        shouldAllowMultilineItems: !1,
        shouldFitContainer: !1,
        shouldFlip: !0,
        trigger: null
    }, Droplist.childContextTypes = {
        shouldAllowMultilineItems: _propTypes2.default.bool
    }, exports.default = Droplist;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("react-dom");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/layer");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/spinner");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/theme");
}, /* 13 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.Trigger = exports.SpinnerContainer = exports.Content = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(14), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _objectWithoutProperties2 = __webpack_require__(15), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: inline-flex;\n\n  ", "\n" ], [ "\n  display: inline-flex;\n\n  ", "\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  0 ", "px ", "px -", "px ", ",\n  0 0 1px ", "\n" ], [ "\n  0 ", "px ", "px -", "px ", ",\n  0 0 1px ", "\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: ", ";\n  box-sizing: border-box;\n  overflow: auto;\n  padding: ", "px 0;\n  max-height: ", ";\n" ], [ "\n  background: ", ";\n  border-radius: ", "px;\n  box-shadow: ", ";\n  box-sizing: border-box;\n  overflow: auto;\n  padding: ", "px 0;\n  max-height: ", ";\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  justify-content: center;\n  min-width: ", "px;\n  padding: ", "px;\n" ], [ "\n  display: flex;\n  justify-content: center;\n  min-width: ", "px;\n  padding: ", "px;\n" ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  cursor: pointer;\n  display: inline-flex;\n  transition-duration: 0.2s;\n  transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n\n  ", "\n" ], [ "\n  cursor: pointer;\n  display: inline-flex;\n  transition-duration: 0.2s;\n  transition: box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);\n\n  ", "\n" ]), _styledComponents = __webpack_require__(11), _styledComponents2 = _interopRequireDefault(_styledComponents), _theme = __webpack_require__(12), getMaxHeight = function(_ref) {
        var isTall = _ref.isTall, maxHeight = _ref.maxHeight, rest = (0, _objectWithoutProperties3.default)(_ref, [ "isTall", "maxHeight" ]);
        if (maxHeight) return maxHeight + "px";
        var heightWithoutPadding = 17, verticalPadding = (0, _theme.gridSize)(rest), height = heightWithoutPadding + 2 * verticalPadding, defaultMaxHeight = 9.5 * height + verticalPadding / 2;
        return isTall ? "none" : defaultMaxHeight + "px";
    };
    exports.default = _styledComponents2.default.div(_templateObject, function(props) {
        return props.fit && "\n    display: block;\n    flex: 1 1 auto;\n  ";
    });
    var backgroundColor = (0, _theme.themed)({
        light: _theme.colors.N0,
        dark: _theme.colors.DN50
    }), boxShadow = (0, _styledComponents.css)(_templateObject2, _theme.math.divide(_theme.gridSize, 2), _theme.gridSize, _theme.math.divide(_theme.gridSize, 4), _theme.colors.N50A, _theme.colors.N60A);
    exports.Content = _styledComponents2.default.div(_templateObject3, backgroundColor, _theme.borderRadius, boxShadow, _theme.math.divide(_theme.gridSize, 2), getMaxHeight), 
    exports.SpinnerContainer = _styledComponents2.default.div(_templateObject4, _theme.math.multiply(_theme.gridSize, 20), _theme.math.multiply(_theme.gridSize, 2.5)), 
    exports.Trigger = _styledComponents2.default.div(_templateObject5, function(props) {
        return props.fit && "\n    box-sizing: border-box;\n    display: block;\n  ";
    });
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/objectWithoutProperties");
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(17), _defineProperty3 = _interopRequireDefault(_defineProperty2), _item = __webpack_require__(18), _theme = __webpack_require__(12), dropdownPadding = {
        bottom: _theme.gridSize,
        left: _theme.math.multiply(_theme.gridSize, 1.5),
        right: _theme.math.multiply(_theme.gridSize, 1.5),
        top: _theme.gridSize
    }, droplistItemTheme = {
        padding: {
            default: dropdownPadding,
            compact: dropdownPadding
        },
        borderRadius: function() {
            return 0;
        },
        default: {
            background: "transparent",
            text: (0, _theme.themed)({
                light: _theme.colors.N800,
                dark: _theme.colors.DN600
            }),
            secondaryText: (0, _theme.themed)({
                light: _theme.colors.N200,
                dark: _theme.colors.DN300
            })
        },
        hover: {
            background: (0, _theme.themed)({
                light: _theme.colors.N20,
                dark: _theme.colors.DN70
            }),
            text: (0, _theme.themed)({
                light: _theme.colors.N800,
                dark: _theme.colors.DN600
            }),
            secondaryText: (0, _theme.themed)({
                light: _theme.colors.N200,
                dark: _theme.colors.DN300
            })
        },
        active: {
            background: (0, _theme.themed)({
                light: _theme.colors.B75,
                dark: _theme.colors.B75
            }),
            text: (0, _theme.themed)({
                light: _theme.colors.N800,
                dark: _theme.colors.B400
            }),
            secondaryText: (0, _theme.themed)({
                light: _theme.colors.N200,
                dark: _theme.colors.DN300
            })
        },
        selected: {
            background: (0, _theme.themed)({
                light: _theme.colors.N0,
                dark: _theme.colors.DN10
            }),
            text: (0, _theme.themed)({
                light: _theme.colors.N800,
                dark: _theme.colors.DN600
            }),
            secondaryText: (0, _theme.themed)({
                light: _theme.colors.N200,
                dark: _theme.colors.DN300
            })
        },
        disabled: {
            background: "transparent",
            text: (0, _theme.themed)({
                light: _theme.colors.N70,
                dark: _theme.colors.DN80
            }),
            secondaryText: (0, _theme.themed)({
                light: _theme.colors.N50,
                dark: _theme.colors.DN70
            })
        },
        focus: {
            outline: (0, _theme.themed)({
                light: _theme.colors.B100,
                dark: _theme.colors.B75
            })
        }
    };
    exports.default = (0, _defineProperty3.default)({}, _item.itemThemeNamespace, droplistItemTheme);
}, /* 17 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 18 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/item");
}, /* 19 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(20), _extends3 = _interopRequireDefault(_extends2), _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _radio = __webpack_require__(21), _radio2 = _interopRequireDefault(_radio), _checkbox = __webpack_require__(22), _checkbox2 = _interopRequireDefault(_checkbox), _tooltip = __webpack_require__(23), _tooltip2 = _interopRequireDefault(_tooltip), _Item = __webpack_require__(24), _utils = __webpack_require__(25), _Element = __webpack_require__(26), _Element2 = _interopRequireDefault(_Element), inputTypes = {
        checkbox: _checkbox2.default,
        radio: _radio2.default
    }, Item = function(_PureComponent) {
        function Item() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, Item);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {
                isHovered: !1,
                isPressed: !1
            }, _this.componentDidMount = function() {
                return document.addEventListener("mouseup", _this.handleMouseUp);
            }, _this.componentWillUnmount = function() {
                return document.removeEventListener("mouseup", _this.handleMouseUp);
            }, _this.guardedActivate = function(event) {
                var _this$props = _this.props, isDisabled = _this$props.isDisabled, onActivate = _this$props.onActivate;
                isDisabled || onActivate({
                    item: _this,
                    event: event
                });
            }, _this.handleClick = function(event) {
                return _this.guardedActivate(event);
            }, _this.handleKeyPress = function(event) {
                var keyIsValid = [ "Enter", " " ].indexOf(event.key) > -1;
                keyIsValid && _this.guardedActivate(event);
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    isPressed: !0
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    isPressed: !1
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    isHovered: !1
                });
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    isHovered: !0
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(Item, _PureComponent), Item.prototype.render = function() {
            var props = this.props, _state = this.state, isHovered = _state.isHovered, isPressed = _state.isPressed, hasInput = [ "checkbox", "radio" ].indexOf(props.type) > -1, Input = inputTypes[props.type], appearanceProps = {
                isActive: "link" === props.type && props.isActive || "option" === props.type && props.isSelected,
                isChecked: [ "checkbox", "radio" ].indexOf(props.type) > -1 && props.isChecked,
                isDisabled: props.isDisabled,
                isFocused: props.isFocused,
                isHidden: props.isHidden,
                isHovered: isHovered,
                isPressed: isPressed,
                isSelected: "option" === props.type && props.isSelected,
                isPrimary: "primary" === props.appearance
            }, element = _react2.default.createElement(_Element2.default, (0, _extends3.default)({}, appearanceProps, {
                handleClick: this.handleClick,
                handleKeyPress: this.handleKeyPress,
                handleMouseOut: this.handleMouseOut,
                handleMouseOver: this.handleMouseOver,
                handleMouseUp: this.handleMouseUp,
                handleMouseDown: this.handleMouseDown,
                href: props.href,
                target: props.target,
                title: props.title,
                type: props.type
            }), hasInput && _react2.default.createElement(_Item.InputWrapper, appearanceProps, _react2.default.createElement(Input, {
                label: "",
                primaryColor: (0, _utils.getInputBackground)(appearanceProps),
                secondaryColor: (0, _utils.getInputFill)(appearanceProps),
                size: "medium"
            })), !!props.elemBefore && _react2.default.createElement(_Item.Before, null, props.elemBefore), _react2.default.createElement(_Item.ContentWrapper, null, _react2.default.createElement(_Item.Content, {
                allowMultiline: this.context.shouldAllowMultilineItems
            }, props.children), !!props.description && _react2.default.createElement(_Item.Description, null, props.description)), !!props.elemAfter && _react2.default.createElement(_Item.After, null, props.elemAfter));
            return _react2.default.createElement("span", {
                role: "presentation"
            }, props.tooltipDescription ? _react2.default.createElement(_tooltip2.default, {
                description: props.tooltipDescription,
                position: props.tooltipPosition
            }, element) : element);
        }, Item;
    }(_react.PureComponent);
    Item.propTypes = {
        appearance: _propTypes2.default.oneOf([ "default", "primary" ]),
        children: _propTypes2.default.node,
        description: _propTypes2.default.string,
        elemAfter: _propTypes2.default.node,
        elemBefore: _propTypes2.default.node,
        href: _propTypes2.default.string,
        isActive: _propTypes2.default.bool,
        isChecked: _propTypes2.default.bool,
        isDisabled: _propTypes2.default.bool,
        isFocused: _propTypes2.default.bool,
        isHidden: _propTypes2.default.bool,
        isSelected: _propTypes2.default.bool,
        onActivate: _propTypes2.default.func,
        target: _propTypes2.default.string,
        title: _propTypes2.default.string,
        tooltipDescription: _propTypes2.default.string,
        tooltipPosition: _propTypes2.default.oneOf([ "top", "bottom", "left", "right" ]),
        type: _propTypes2.default.oneOf([ "link", "radio", "checkbox", "option" ])
    }, Item.defaultProps = {
        appearance: "default",
        children: null,
        description: "",
        elemAfter: null,
        elemBefore: null,
        href: null,
        isActive: !1,
        isChecked: !1,
        isDisabled: !1,
        isFocused: !1,
        isHidden: !1,
        isSelected: !1,
        itemContext: "menu",
        onActivate: function() {},
        target: null,
        title: null,
        tooltipDescription: null,
        tooltipPosition: "right",
        type: "link"
    }, Item.contextTypes = {
        shouldAllowMultilineItems: _propTypes2.default.bool
    }, exports.default = Item;
}, /* 20 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 21 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/icon/glyph/radio");
}, /* 22 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/icon/glyph/checkbox");
}, /* 23 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/tooltip");
}, /* 24 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.SecondaryText = exports.Description = exports.Content = exports.ContentWrapper = exports.After = exports.Before = exports.InputWrapper = exports.Span = exports.Anchor = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(14), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  box-shadow: 0 0 0 2px ", " inset;\n  outline: none;\n  outline-offset: 0;\n  position: relative; /* prevents bgcolor of a hovered element from obfuscating focus ring of a focused sibling element */\n" ], [ "\n  box-shadow: 0 0 0 2px ", " inset;\n  outline: none;\n  outline-offset: 0;\n  position: relative; /* prevents bgcolor of a hovered element from obfuscating focus ring of a focused sibling element */\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  &, &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n" ], [ "\n  &, &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  color: ", ";\n" ], [ "\n  color: ", ";\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  cursor: ", ";\n  display: ", ";\n  flex-wrap: nowrap;\n  font-size: ", "px;\n  font-weight: normal;\n  padding: 0 ", "px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n\n    ", "\n  }\n  &:active {\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n  }\n  &:focus { ", " }\n\n  ", "\n  ", "\n  ", "\n" ], [ "\n  align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  cursor: ", ";\n  display: ", ";\n  flex-wrap: nowrap;\n  font-size: ", "px;\n  font-weight: normal;\n  padding: 0 ", "px;\n  text-decoration: none;\n\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n    text-decoration: none;\n\n    ", "\n  }\n  &:active {\n    background-color: ", ";\n    color: ", ";\n\n    ", "\n  }\n  &:focus { ", " }\n\n  ", "\n  ", "\n  ", "\n" ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n" ], [ "\n  ", "\n" ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  margin: 0 2px;\n" ], [ "\n  display: flex;\n  margin: 0 2px;\n" ]), _templateObject7 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n" ], [ "\n  display: flex;\n" ]), _templateObject8 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: center;\n  display: flex;\n" ], [ "\n  align-items: center;\n  display: flex;\n" ]), _templateObject9 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  display: flex;\n  flex-direction: column;\n  margin: 0 ", "px;\n  padding: ", "px 0;\n  overflow: hidden;\n\n  &:first-child { margin: 0; }\n" ], [ "\n  display: flex;\n  flex-direction: column;\n  margin: 0 ", "px;\n  padding: ", "px 0;\n  overflow: hidden;\n\n  &:first-child { margin: 0; }\n" ]), _templateObject10 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", "\n" ], [ "\n  flex: 1 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  ", "\n" ]), _templateObject11 = (0, 
    _taggedTemplateLiteral3.default)([ "white-space: normal;" ], [ "white-space: normal;" ]), _templateObject12 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  color: ", ";\n  flex: 1 1 auto;\n  font-size: 12px;\n  line-height: 16 / 12;\n  margin-top: ", "px;\n" ], [ "\n  color: ", ";\n  flex: 1 1 auto;\n  font-size: 12px;\n  line-height: 16 / 12;\n  margin-top: ", "px;\n" ]), _styledComponents = __webpack_require__(11), _styledComponents2 = _interopRequireDefault(_styledComponents), _theme = __webpack_require__(12), activeBackgroundColor = (0, 
    _theme.themed)({
        light: _theme.colors.B75,
        dark: _theme.colors.DN30
    }), hoverBackgroundColor = (0, _theme.themed)({
        light: _theme.colors.N20,
        dark: _theme.colors.DN60
    }), selectedBackgroundColor = (0, _theme.themed)({
        light: _theme.colors.N0,
        dark: _theme.colors.DN30
    }), activePrimaryTextColor = (0, _theme.themed)({
        light: _theme.colors.N800,
        dark: _theme.colors.DN300
    }), defaultPrimaryTextColor = (0, _theme.themed)({
        light: _theme.colors.N800,
        dark: _theme.colors.DN600
    }), disabledPrimaryTextColor = (0, _theme.themed)({
        light: _theme.colors.N70,
        dark: _theme.colors.DN70
    }), primaryPrimaryTextColor = (0, _theme.themed)({
        light: _theme.colors.B400,
        dark: _theme.colors.B400
    }), selectedPrimaryTextColor = (0, _theme.themed)({
        light: _theme.colors.N800,
        dark: _theme.colors.N800
    }), focusedStyles = (0, _styledComponents.css)(_templateObject, (0, _theme.themed)({
        light: _theme.colors.B100,
        dark: _theme.colors.B75
    })), activeStyles = (0, _styledComponents.css)(_templateObject2, selectedBackgroundColor, selectedPrimaryTextColor), primaryStyles = (0, 
    _styledComponents.css)(_templateObject3, primaryPrimaryTextColor), sharedStyles = function(props) {
        return (0, _styledComponents.css)(_templateObject4, props.isDisabled ? disabledPrimaryTextColor : defaultPrimaryTextColor, props.isDisabled ? "not-allowed" : "pointer", props.isHidden ? "none" : "flex", _theme.fontSize, _theme.math.multiply(_theme.gridSize, 1.5), !props.isDisabled && hoverBackgroundColor, props.isDisabled ? disabledPrimaryTextColor : defaultPrimaryTextColor, props.isPrimary && primaryStyles, !props.isDisabled && activeBackgroundColor, !props.isDisabled && activePrimaryTextColor, props.isPrimary && primaryStyles, focusedStyles, props.isFocused && focusedStyles, props.isActive && activeStyles, props.isPrimary && primaryStyles);
    };
    exports.Anchor = _styledComponents2.default.a(_templateObject5, function(props) {
        return sharedStyles(props);
    }), exports.Span = _styledComponents2.default.span(_templateObject5, function(props) {
        return sharedStyles(props);
    }), exports.InputWrapper = _styledComponents2.default.span(_templateObject6), exports.Before = _styledComponents2.default.span(_templateObject7), 
    exports.After = _styledComponents2.default.span(_templateObject8), exports.ContentWrapper = _styledComponents2.default.span(_templateObject9, _theme.gridSize, _theme.gridSize), 
    exports.Content = _styledComponents2.default.span(_templateObject10, function(props) {
        return props.allowMultiline && (0, _styledComponents.css)(_templateObject11);
    }), exports.Description = _styledComponents2.default.span(_templateObject12, _theme.colors.subtleText, _theme.math.divide(_theme.gridSize, 2)), 
    exports.SecondaryText = _styledComponents2.default.span(_templateObject3, _theme.colors.subtleText);
}, /* 25 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function getInputBackground(_ref) {
        var isChecked = _ref.isChecked, isDisabled = _ref.isDisabled, isHovered = _ref.isHovered, isPressed = _ref.isPressed, background = _theme.colors.N40;
        return isHovered && (background = _theme.colors.N50), isPressed && (background = _theme.colors.B200), 
        isChecked && (background = _theme.colors.B400), isDisabled && (background = _theme.colors.N20), 
        isChecked && isDisabled && (background = _theme.colors.N600), background;
    }
    function getInputFill(_ref2) {
        var isChecked = _ref2.isChecked;
        return isChecked ? _theme.colors.N0 : "transparent";
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.getInputBackground = getInputBackground, exports.getInputFill = getInputFill;
    var _theme = __webpack_require__(12);
}, /* 26 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.baseTypes = exports.ariaRoles = exports.supportsVoiceOver = void 0;
    var _extends2 = __webpack_require__(20), _extends3 = _interopRequireDefault(_extends2), _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _Item = __webpack_require__(24), supportsVoiceOver = exports.supportsVoiceOver = /Mac OS X/.test(navigator.userAgent), ariaRoles = exports.ariaRoles = {
        checkbox: supportsVoiceOver ? "checkbox" : "menuitemcheckbox",
        link: "menuitem",
        option: "option",
        radio: supportsVoiceOver ? "radio" : "menuitemradio"
    }, baseTypes = exports.baseTypes = {
        default: "link",
        values: [ "link", "radio", "checkbox", "option" ]
    }, Element = function(_PureComponent) {
        function Element() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, Element);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.handleMouseDown = function(e) {
                e.preventDefault(), _this.props.handleMouseDown();
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        // this prevents the focus ring from appearing when the element is clicked.
        // It doesn't interfere with the onClick handler
        return (0, _inherits3.default)(Element, _PureComponent), Element.prototype.render = function() {
            var props = this.props, isActive = props.isActive, isChecked = props.isChecked, isDisabled = props.isDisabled, isFocused = props.isFocused, isHidden = props.isHidden, isSelected = props.isSelected, isPrimary = props.isPrimary, appearanceProps = {
                isActive: isActive,
                isChecked: isChecked,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isHidden: isHidden,
                isSelected: isSelected,
                isPrimary: isPrimary
            }, ariaProps = {
                "aria-checked": !!isChecked,
                "aria-disabled": !!isDisabled,
                "aria-hidden": !!isHidden,
                "aria-selected": !!isSelected
            }, commonProps = {
                "data-role": "droplistItem",
                onClick: props.handleClick,
                onKeyPress: props.handleKeyPress,
                onMouseDown: this.handleMouseDown,
                onMouseOut: props.handleMouseOut,
                onMouseOver: props.handleMouseOver,
                onMouseUp: props.handleMouseUp,
                role: ariaRoles[props.type],
                title: props.title,
                tabIndex: "option" === props.type ? null : 0
            }, testingProps = {}, consolidatedProps = (0, _extends3.default)({}, appearanceProps, ariaProps, commonProps, testingProps);
            return props.href && !isDisabled ? _react2.default.createElement(_Item.Anchor, (0, 
            _extends3.default)({
                href: props.href,
                target: props.target
            }, consolidatedProps), props.children) : _react2.default.createElement(_Item.Span, consolidatedProps, props.children);
        }, Element;
    }(_react.PureComponent);
    Element.propTypes = {
        children: _propTypes2.default.node,
        handleClick: _propTypes2.default.func,
        handleKeyPress: _propTypes2.default.func,
        handleMouseDown: _propTypes2.default.func.isRequired,
        handleMouseOut: _propTypes2.default.func.isRequired,
        handleMouseOver: _propTypes2.default.func.isRequired,
        handleMouseUp: _propTypes2.default.func.isRequired,
        href: _propTypes2.default.string,
        isActive: _propTypes2.default.bool,
        isChecked: _propTypes2.default.bool,
        isDisabled: _propTypes2.default.bool,
        isFocused: _propTypes2.default.bool,
        isHidden: _propTypes2.default.bool,
        isPrimary: _propTypes2.default.bool,
        isSelected: _propTypes2.default.bool,
        target: _propTypes2.default.string,
        title: _propTypes2.default.string,
        type: _propTypes2.default.oneOf(baseTypes.values)
    }, exports.default = Element;
}, /* 27 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(4), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(5), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(6), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(7), _propTypes2 = _interopRequireDefault(_propTypes), _Group = __webpack_require__(28), _Group2 = _interopRequireDefault(_Group), DroplistGroup = function(_PureComponent) {
        function DroplistGroup() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, DroplistGroup);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {
                ariaLabel: _this.props.heading
            }, _this.componentDidMount = function() {
                (_this.props.heading || _this.props.elemAfter) && _this.setState({
                    ariaLabel: _this.getAriaLabel()
                });
            }, _this.componentDidUpdate = function() {
                (_this.props.heading || _this.props.elemAfter) && _this.setState({
                    ariaLabel: _this.getAriaLabel()
                });
            }, _this.getAriaLabel = function() {
                var _this$props = _this.props, elemAfter = _this$props.elemAfter, heading = _this$props.heading, afterText = elemAfter && "string" == typeof elemAfter ? elemAfter : _this.headingElement && _this.headingElement.textContent;
                return heading + " " + (afterText || "");
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(DroplistGroup, _PureComponent), DroplistGroup.prototype.render = function() {
            var _this2 = this, _props = this.props, children = _props.children, elemAfter = _props.elemAfter, heading = _props.heading, ariaLabel = this.state.ariaLabel;
            return _react2.default.createElement(_Group2.default, {
                "aria-label": ariaLabel,
                role: "group"
            }, heading ? _react2.default.createElement(_Group.Heading, {
                "aria-hidden": "true",
                "data-role": "droplistGroupHeading"
            }, _react2.default.createElement(_Group.HeadingText, null, heading), elemAfter ? _react2.default.createElement(_Group.HeadingAfter, {
                innerRef: function(r) {
                    return _this2.headingElement = r;
                }
            }, elemAfter) : null) : null, children);
        }, DroplistGroup;
    }(_react.PureComponent);
    DroplistGroup.propTypes = {
        children: _propTypes2.default.node,
        elemAfter: _propTypes2.default.oneOfType([ _propTypes2.default.node, _propTypes2.default.string ]),
        heading: _propTypes2.default.string
    }, DroplistGroup.displayName = "Group", exports.default = DroplistGroup;
}, /* 28 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.HeadingText = exports.HeadingAfter = exports.Heading = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(14), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  box-sizing: border-box;\n  display: block;\n  margin-top: ", "px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n" ], [ "\n  box-sizing: border-box;\n  display: block;\n  margin-top: ", "px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  align-items: baseline;\n  color: ", ";\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ", "px ", "px;\n" ], [ "\n  align-items: baseline;\n  color: ", ";\n  display: flex;\n  flex: 1 1 auto;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1;\n  margin: 0;\n  padding: ", "px ", "px;\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex: 0 0 auto;\n" ], [ "\n  flex: 0 0 auto;\n" ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n" ], [ "\n  flex: 1 1 auto;\n  font-size: 12px;\n  text-transform: uppercase;\n" ]), _styledComponents = __webpack_require__(11), _styledComponents2 = _interopRequireDefault(_styledComponents), _theme = __webpack_require__(12);
    exports.default = _styledComponents2.default.div(_templateObject, _theme.gridSize);
    exports.Heading = _styledComponents2.default.div(_templateObject2, (0, _theme.themed)({
        light: _theme.colors.N300,
        dark: _theme.colors.DN300
    }), _theme.gridSize, _theme.math.multiply(_theme.gridSize, 1.5)), exports.HeadingAfter = _styledComponents2.default.div(_templateObject3), 
    exports.HeadingText = _styledComponents2.default.div(_templateObject4);
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/droplist/dist/bundle-cjs.js
// module id = 334
// module chunks = 0